import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DeleteButtonComponent {
  @Input() isLoading: boolean

  @Output() delete = new EventEmitter<never>()

  onDelete(event: MouseEvent): void {
    event.stopPropagation()
    this.delete.emit()
  }
}
